import { render, staticRenderFns } from "./DetailsCourseAssignCourseTemplateModal.vue?vue&type=template&id=c8f4f6b0&scoped=true&"
import script from "./DetailsCourseAssignCourseTemplateModal.vue?vue&type=script&lang=js&"
export * from "./DetailsCourseAssignCourseTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f4f6b0",
  null
  
)

export default component.exports